module.exports = __webpack_public_path__ + "img/face-smile-horns.81006a94.svg";